"use client";

import { getAwardPeriods } from "@/lib/conditions/awards-periods";
import {
  useShallowSearchParam,
  setShallowSearchParams,
} from "@/lib/hooks/use-shallow-search-param";

export function SeasonSelector() {
  const current = useShallowSearchParam("period") ?? "all-time";

  function handleChange(e: React.ChangeEvent<HTMLSelectElement>) {
    const value = e.target.value;
    // Shallow URL update (no navigation, no RSC refetch). The AwardsBrowser
    // subscribes to the same store and fetches the new period.
    setShallowSearchParams({ period: value === "all-time" ? null : value });
  }

  const periods = getAwardPeriods();

  return (
    <select
      value={current}
      onChange={handleChange}
      className="appearance-none bg-white border border-border-light rounded-[10px] px-4 py-2.5 pr-10 text-[14px] font-semibold text-navy cursor-pointer font-sans transition-all hover:border-gold/40 focus:border-gold/60 focus:outline-none min-h-[44px]"
      aria-label="Select time period"
    >
      <optgroup label="Overview">
        <option value="all-time">All time</option>
      </optgroup>
      <optgroup label="By year">
        {periods.filter((p) => p.key.startsWith("year-")).map((p) => (
          <option key={p.key} value={p.key}>{p.label}</option>
        ))}
      </optgroup>
      <optgroup label="By month">
        {periods.filter((p) => p.key.startsWith("month-")).map((p) => (
          <option key={p.key} value={p.key}>{p.label}</option>
        ))}
      </optgroup>
    </select>
  );
}
